import { z } from "zod";
import { ClientLinkIdSchema } from "../primitives/ids.js";
import { CanonicalPresentationModelV1Schema } from "./canonical-presentation.js";
/**
 * Client-portal transport envelope for a single derived canonical presentation model
 * (ENR-UX-009 Step 4). Carries the named outcome alongside the presentation model and a
 * poll-interval hint — never a second source of lifecycle or eligibility truth.
 */
export const ClientJourneyPresentationV1Schema = z
    .object({
    schemaId: z.literal("client-portal.journeyPresentation.v1"),
    clientLinkId: ClientLinkIdSchema,
    generatedAt: z.string().datetime(),
    outcome: z.string().min(1),
    presentation: CanonicalPresentationModelV1Schema,
    suggestedPollIntervalMs: z.number().int().positive(),
})
    .strict();
//# sourceMappingURL=client-journey-presentation.js.map